import React from 'react';
import  { useState, useEffect } from 'react';
import Mentor from './Mentor';
import Body from './Body';
import SuccessStories from './SuccessStories';
import Testimonials from './Testimonials';
import SidebarQuickForm from './SidebarQuickForm';
import './classes/SidebarQuickForm.css';
import './classes/NextStartDate.css';
import './classes/PaymentDetailBox.css';
import './classes/Page.css';
import './classes/HomePage.css';
import { configData } from "../config";
import { deriveVisualPageType, isValidVisualPageType } from "../constants/visualPageTypes";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import EditNewCourse from './EditNewCourse';
import ViewTestimonialPage from './ViewTestimonialPage';
import EditTestimonialPage from './EditTestimonialPage';
import EditSuccessStoryPage from './EditSuccessStoryPage';
import ViewSuccessStoryPage from './ViewSuccessStoryPage';
import BlockRenderer from './BlockRenderer';
import PageEditor from './PageEditor/PageEditor';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';

// Visual-page helpers (kept module-level so multiple Page instances share the same behaviour).
const emptyVisualTree = () => ({
  id: Math.random().toString(36).slice(2, 10),
  type: 'root',
  props: {},
  children: [],
});
const parseVisualBody = (body) => {
  try {
    const obj = JSON.parse(body || '{}');
    if (obj && obj.tree && obj.tree.type === 'root') return obj.tree;
  } catch (e) {}
  return emptyVisualTree();
};
// Persist the working tree to the visual_pages row. `status` is OPTIONAL and
// drives publish state: pass 1 to publish (make it publicly viewable) or 0 to
// unpublish; omit it entirely for a normal Save so the publish state is left
// untouched (the backend only writes status when the key is present — see
// PagesController::actionSavevisualpage). This keeps ordinary Save/autosave
// from ever changing whether a page is public.
const saveVisualPage = async (nid, tree, status) => {
  const payload = { nid, body: JSON.stringify({ version: 2, tree }) };
  if (status !== undefined) payload.status = status;
  const res = await fetch(configData.APP_URL + 'pages/savevisualpage', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || (data && data.code && data.code !== 0)) {
    throw new Error((data && data.message) || ('HTTP ' + res.status));
  }
  return data;
};

// Fork the current tree into a brand-new visual_pages row. Prompts for
// title (with a "(copy)" suffix on the current title as the default) and
// derives a slug from it. Returns `false` if the user cancels the prompts
// so PageEditor can reset its "saving…" state silently; otherwise resolves
// to the create response and navigates the browser to the new page's
// /edit route.
const slugifyTitle = (s) =>
  (s || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 128);
const saveVisualPageAsNew = async (tree, currentPage) => {
  const defaultTitle = ((currentPage && currentPage.title) || 'New page') + ' (copy)';
  const title = window.prompt('Title for the new visual page:', defaultTitle);
  if (title === null) return false;
  const trimmedTitle = title.trim();
  if (!trimmedTitle) throw new Error('Title is required.');
  const defaultSlug = slugifyTitle(trimmedTitle);
  const slug = window.prompt('URL slug for the new visual page:', defaultSlug);
  if (slug === null) return false;
  const trimmedSlug = (slug || '').trim();
  if (!trimmedSlug) throw new Error('URL slug is required.');
  // Resolve the page_type for the duplicate. The backend requires a valid value
  // (course | conference), so a blank stored value cannot simply be passed
  // through. deriveVisualPageType preserves an already-valid page_type and,
  // for legacy rows where it is blank, infers it from authoritative page
  // metadata — the courses/ | conferences/ source path recorded on the page's
  // tree, else a course-only sourceNid binding (see visualPageTypes.js). It is
  // never hardcoded. When the type genuinely cannot be determined we stop and
  // report the missing data rather than guessing.
  const pageType = deriveVisualPageType(currentPage, tree);
  if (!isValidVisualPageType(pageType)) {
    throw new Error(
      'Cannot save as new: this page has no page_type and its content records no ' +
      'course/conference source to infer it from. Set the page type (or bind it to a ' +
      'source course/conference) before duplicating.'
    );
  }
  const res = await fetch(configData.APP_URL + 'pages/createvisualpage', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      title: trimmedTitle,
      url_slug: trimmedSlug,
      page_type: pageType,
      body: JSON.stringify({ version: 2, tree }),
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || (data && data.code && data.code !== 0)) {
    throw new Error((data && data.message) || ('HTTP ' + res.status));
  }
  const createdSlug = (data && data.data && data.data.url_slug) || trimmedSlug;
  // Redirect to the new page's editor so the admin lands in the new context.
  window.location.href = '/' + createdSlug + '/edit';
  return data;
};

const Page = () => {

    const app_url = configData.APP_URL; 
    const {tab} = useParams();
    const {slug} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    // "/" has no path of its own: it shows the configured home page
    const path = location.pathname.replace(/^\/+/, "") || configData.HOME_PAGE_PATH;
    // Visual-page lookup key. `path` keeps the browser path verbatim (including
    // a trailing "/edit") so pages/getpagedata is unchanged; visual_pages rows
    // are keyed on the bare url_slug, so the "/edit" suffix must come off or
    // pages/getvisualpage 404s for every freshly created page (which lands on
    // /<slug>/edit via a route change, mounting Page fresh) and on any hard
    // refresh of an /edit URL.
    const visualPath = path.replace(/\/edit$/, "");
    function updateToggle(id){
        setToggle(id);
        if (!page) return;
        if(id == 1) {
          navigate(page.url_slug);
        }
        if(id == 2) {
        navigate('/'+page.url_source+'/edit');
        //window.location.href='/'+page.url_source+'/edit'
        }
    }
    const [toggle, setToggle] = useState(1);
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(null);

    useEffect(() => {
      if (window.location.pathname.endsWith("/edit")) {
        setToggle(2);
    } else {
        setToggle(1);
    }
        Promise.all([
          getuserloggedinroles(),
          getPageData()
        ])
        .then(() => {

        setIsLoading(false);
        })

    },[]);

    // Public view for Visual Pages: once both auth and page have resolved,
    // if the visitor is not an admin and lands on a /foo/edit URL for a
    // visual page, drop the /edit suffix so they see the read-only public
    // page at /foo. Scoped to page.type === "visual" so existing non-visual
    // routes (course/edit, testimonial/edit, etc.) are unchanged.
    useEffect(() => {
      if (isLoading) return;
      const roles = userLoggedInRoles || [];
      const admin = roles.includes(configData.ROLE_SAADMIN) || roles.includes(configData.ROLE_ADMINISTRATOR);
      if (page?.type === 'visual' && !admin && location.pathname.endsWith('/edit')) {
        navigate(location.pathname.replace(/\/edit$/, ''), { replace: true });
      }
    }, [isLoading, userLoggedInRoles, page, location.pathname, navigate]);

    async function getuserloggedinroles() {
         try {
          setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
       
    }   
async function getPageData() {
         try {
          setIsLoading(true);
            const response = await fetch(
                app_url+'pages/getpagedata?path='+path,
                {
                    method: "GET",

                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               setPage(responsedata.data);
               return;
            }
            // Fall through: try the Visual Pages CMS (separate `visual_pages` table).
            // Only fires when the existing pages/getpagedata endpoint has no row —
            // so existing course/testimonial/blog/etc. pages are unaffected.
            const r2 = await fetch(
                app_url+'pages/getvisualpage?path='+visualPath,
                { method: 'GET', headers: { 'Content-Type': 'application/json' }, credentials: 'include' }
            );
            const d2 = await r2.json().catch(() => ({}));
            if (d2 && d2.data) {
               setPage(d2.data);
            }
        } catch (err) {

      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }

    }
     // Helper: Convert page.type string (e.g. "conference" -> "Conference")
    const getEntityLabel = () => {
        if (!page?.type) return "Page";
        return page.type.charAt(0).toUpperCase() + page.type.slice(1);
    };

    // Dynamic Title Generator based on Mode and Page Type
    const getPageTitle = () => {
        const title = page?.title || "";
        const entityLabel = getEntityLabel();

        if (toggle === 1) {
            return title ? title : entityLabel;
        } else if (toggle === 2) {
            return title ? `Edit ${entityLabel} - ${title}` : `Edit ${entityLabel}`;
        }
        return entityLabel;
    };

    // Dynamic Edit Component Switcher
    const renderEditComponent = () => {
        switch (page?.type) {
            case "course":
                return <EditNewCourse page={page} />;
            // case "conference":
            //     return <EditNewConferencePage page={page} />; 
            default:
                return <div>No editor available for this page type.</div>;
        }
    };
  const isAdmin = userLoggedInRoles?.includes(configData.ROLE_SAADMIN) || userLoggedInRoles?.includes(configData.ROLE_ADMINISTRATOR);
  // Administrator (role 3) only. Used to gate CTA text/type editing controls in
  // the Visual Page Editor — SAAdmin (role 8) keeps editor access but must not
  // get those controls.
  const isAdministrator = userLoggedInRoles?.includes(configData.ROLE_ADMINISTRATOR);
  return (
        <>
        <Helmet>
           <title>{getPageTitle()}</title>
        </Helmet>
       {isLoading ? (<Loading />) : page?.type === "visual" && !isAdmin && Number(page?.status) !== 1 ? (
         // Draft visual page requested by a non-admin visitor. Backend already
         // filters unpublished pages from public reads; this is defence-in-depth
         // so a leaked draft is never rendered to a normal user.
         <div id="main" className="visual-page-wrap" style={{ padding: '80px 20px', textAlign: 'center' }}>
           <h1 style={{ margin: 0, fontSize: 28, color: '#1f2937' }}>Page not found</h1>
           <p style={{ color: '#6b7280', marginTop: 8 }}>The page you're looking for isn't available.</p>
         </div>
       ) : page?.type === "visual" ? (
         <div id="main" className="visual-page-wrap" style={{ padding: 0 }}>
           {isAdmin && (
             <ul className="tabs primarya">
               <li className={toggle === 1 ? "active" : ""} onClick={() => updateToggle(1)}>
                 <a style={{ cursor: "pointer" }}>View</a>
               </li>
               <li className={toggle === 2 ? "active" : ""} onClick={() => updateToggle(2)}>
                 <a style={{ cursor: "pointer" }}>Edit</a>
               </li>
             </ul>
           )}
           {toggle === 2 && isAdmin ? (
             <PageEditor
               initialTree={parseVisualBody(page.body)}
               onSave={(tree) => saveVisualPage(page.nid, tree)}
               onSaveAsNew={(tree) => saveVisualPageAsNew(tree, page)}
               onPublish={(tree, status) => saveVisualPage(page.nid, tree, status)}
               published={Number(page.status) === 1}
               storageKey={"pageBuilder:draft:" + page.nid}
               contextPage={page}
               pageType={page.page_type}
               isAdministrator={isAdministrator}
             />
           ) : (
             <PageEditor
               readOnly
               initialTree={parseVisualBody(page.body)}
               contextPage={page}
               pageType={page.page_type}
             />
           )}
         </div>
       ) : (
         <><div className={toggle === 1 ? "show-content" : "content"}>
          <div id="main" className={'three-column-layout course-landing-page-container page-node-' + page?.nid}>
            {/* LEFT SIDEBAR CONTROLLER */}
            <aside className="left desktop-only">
               {page?.type === "course" && (
                <>
              <Mentor page={page} />
              <SidebarQuickForm page={page} />
              </>
               )}
            </aside>

            {/* MIDDLE CONTENT BOARDS (2 Components) */}
            <main className="center">
              {(userLoggedInRoles?.includes(configData.ROLE_SAADMIN) || userLoggedInRoles?.includes(configData.ROLE_ADMINISTRATOR)) &&
                <ul className="tabs primarya">
                  <li className={toggle === 1 ? "active" : ""} onClick={() => updateToggle(1)}>
                    <a style={{ cursor: "pointer" }}>View</a>
                  </li>

                  <li className={toggle === 2 ? "active" : ""} onClick={() => updateToggle(2)}>
                    <a style={{ cursor: "pointer" }}>Edit</a>
                  </li>
                  {/* )} */}
                </ul>}
                {(page?.type === "course" || page?.type === "page" || page?.type === "conferences") && (
                  <Body page={page} />
                )}
                {page?.type === "course" && page?.blocks?.map((block) => (
                <BlockRenderer
                key={block.id}
                block={block}
                page={page}
                />
                ))}
                {page?.type === "testimonial" && (
                  <ViewTestimonialPage page={page} />
                )}
                {page?.type === "success_story" && (
                  <ViewSuccessStoryPage page={page} />
                )}
            </main>

            {/* RIGHT SIDEBAR CONTROLLER (2 Components) */}
            <aside className="right">
              {page?.type === "course" && (
                <>
              <SuccessStories page={page}/>
              <Testimonials page={page}/></>
              )}
            </aside>
          </div></div><div className={toggle === 2 ? "show-content" : "content"}>
             {page?.type === "course" && (
            <EditNewCourse />
            )}
            {page?.type === "testimonial" && (
              <EditTestimonialPage />
            )}
            {page?.type === "success_story" && (
              <EditSuccessStoryPage />
            )}
           
          </div></>
   
    )}</>
  );
};
export default Page;